import http from "../http-common";
/* eslint-disable */
class TelehealthService {
  historyList(page, itemPerPage, keyword) {
    return http.get(
      "/telehealth/riwayat-konsultasi-list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  getInvoice(id) {
    return http.get("/telehealth/invoice/" + id, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.deskripsi) bodyFormData.append("deskripsi", data.deskripsi);

    if (data.file_foto != null) bodyFormData.append("photo", data.file_foto);

    return http.post("/telehealth", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.deskripsi) bodyFormData.append("deskripsi", data.deskripsi);

    if (data.file_foto != null) bodyFormData.append("photo", data.file_foto);

    return http.put(`/telehealth/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/telehealth/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  sendtelehealth(id) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);

    return http.post(`/telehealth-send`, bodyFormData, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  canceltelehealth(id) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);

    return http.post(`/telehealth-cancel`, bodyFormData, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  sendResponseKlien(id, deskripsi) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("deskripsi", deskripsi);

    return http.post("/telehealth/broadcast/user/send", bodyFormData, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  sendResponseDokter(id, deskripsi) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("deskripsi", deskripsi);

    return http.post("/telehealth/broadcast/dokter/send", bodyFormData, {
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new TelehealthService();
